import '../../styles/main.css'
import '../../styles/LoadingTable.css'

function LoadingTable () {

    return(
        <>
        <table className='table-pattern-sistem w-[100%] borda-cinza'>
            <thead className='bg-neutro'>
                <tr>
                    <th><div className='one h-[15px] w-[50px] bg-neutro rounded-[12px]'> </div></th>
                    <th><div className='one h-[15px] w-[130px] bg-neutro rounded-[12px]'> </div></th>
                    <th><div className='one h-[15px] w-[80px] bg-neutro rounded-[12px]'> </div></th>
                    <th><div className='one h-[15px] w-[130px] bg-neutro rounded-[12px]'> </div></th>
                    <th><div className='one h-[15px] w-[100px] bg-neutro rounded-[12px]'> </div></th>
                    <th><div className='one h-[15px] w-[150px] bg-neutro rounded-[12px]'> </div></th>
                </tr>

            </thead>

            <tbody>
                <tr className='row hover:cursor-pointer hover:bg-neutro'>
                    <td> <div className='two h-[15px] w-[30px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[110px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[60px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[110px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[80px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[120px] bg-neutro rounded-[12px]'> </div> </td>
                </tr>
                <tr className='row hover:cursor-pointer hover:bg-neutro'>
                    <td> <div className='one h-[15px] w-[50px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[130px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[80px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[130px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[100px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[150px] bg-neutro rounded-[12px]'> </div> </td>
                </tr>
                <tr className='row hover:cursor-pointer hover:bg-neutro'>
                    <td> <div className='two h-[15px] w-[30px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[110px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[60px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[110px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[80px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[120px] bg-neutro rounded-[12px]'> </div> </td>
                </tr>
                <tr className='row hover:cursor-pointer hover:bg-neutro'>
                    <td> <div className='one h-[15px] w-[50px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[130px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[80px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[130px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[100px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[150px] bg-neutro rounded-[12px]'> </div> </td>
                </tr>
                <tr className='row hover:cursor-pointer hover:bg-neutro'>
                    <td> <div className='two h-[15px] w-[30px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[110px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[60px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[110px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[80px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[120px] bg-neutro rounded-[12px]'> </div> </td>
                </tr>
                <tr className='row hover:cursor-pointer hover:bg-neutro'>
                    <td> <div className='one h-[15px] w-[50px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[130px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[80px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[130px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[100px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[150px] bg-neutro rounded-[12px]'> </div> </td>
                </tr>
                <tr className='row hover:cursor-pointer hover:bg-neutro'>
                    <td> <div className='two h-[15px] w-[30px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[110px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[60px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[110px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[80px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='two h-[15px] w-[120px] bg-neutro rounded-[12px]'> </div> </td>
                </tr>
                <tr className='row hover:cursor-pointer hover:bg-neutro'>
                    <td> <div className='one h-[15px] w-[50px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[130px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[80px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[130px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[100px] bg-neutro rounded-[12px]'> </div> </td>
                    <td> <div className='one h-[15px] w-[150px] bg-neutro rounded-[12px]'> </div> </td>
                </tr>

            </tbody>
        </table>
        </>

    )
}

export default LoadingTable